import { useFormikContext } from 'formik';
import React from 'react'

export default function HomeInput({boxClassName, label, labelClass, name, type, placeholder, disabled}) {
    const {
        handleChange,
        errors,
        touched,
        setFieldTouched,
        values,
      } = useFormikContext();

//HOMELAYOUT2
  
return (
  <div className={`my-3 ${boxClassName}`}>
    <label className={`hidden md:block my-2 font-bold md:font-semibold text-md md:text-center text-slate-700 uppercase`} for={name}>
        {label||name}
    </label>
    <input 
    name={name} 
    type={type}
    disabled={disabled}
    onBlur={() => {
        setFieldTouched(name);
      }}
    placeholder={placeholder}
    value={values[name]}
    onChange={handleChange}
    className="text-center md:mb-2 md:shadow-b appearance-none hover:outline-none border-b-2 border-y-slate-400 md:rounded-lg hover:md:border-2 hover:border-sky-400  w-full py-2 mt-2 px-3 text-gray-800 
          leading-tight focus:outline-none focus:shadow-outline" id={name}/>

    <div className='text-center ml-1'>
    {touched[name] && errors[name] && (
      <div className='text-red-400' style={{fontSize: ".9rem" }}>
        {errors[name]}
      </div>
    )}
    </div>
  </div>   
  )}